import React from "react"
import Img from "gatsby-image"

const Founder = (props) => {

  const data = props.data

  return (
    <div className="bg-white">
      {data.memberProfiles.map(element => {
        return(
          <div className="container welcome mx-auto t-grid text-black py-16 pb-24 lg:pb-32 space-y-12 lg:space-y-20 lg:items-center">
            <div className="col-span-full lg:col-start-2 lg:col-span-3">
              <h2>{element.heading}</h2>
            </div>
            <div className="relative col-span-full sm:col-start-1 sm:col-span-2 lg:col-start-2 lg:col-span-3 flex justify-center">
              <div className="h-3/4 w-3/4 lg:h-full lg:w-full">
                <Img
                  fluid={element.profilePicture.fluid}
                  className="z-10"
                ></Img>
                <div className="absolute border-solid border gray-1-border -left-0 top-7 lg:-left-12 lg:top-12 h-full w-3/4 lg:w-full z-0"></div>
              </div>
            </div>
            <div className="col-span-full lg:col-start-5 lg:col-span-5 space-y-4 lg:space-y-6 lg:ml-7">
              <div className="space-y-1">
                <h4>{element.name}</h4>
                <h6 className="gray-2">{element.position}</h6>
              </div>
              <p className="body-1">{element.bio.bio}</p>
            </div>
          </div>
        )
      })}  
    </div>
  )
}

export default Founder
